import React from "react";
import starIcon from "../../assets/images/star-icon.png";
import study1 from "../../assets/images/case-study/case-study1.jpg";
import { useTranslation } from "gatsby-plugin-react-i18next";

const E = () => {
	const { t } = useTranslation();
	return (
		<div className="case-study-area bg-fffbf5">
			<div className="single-case-study-item ptb-100">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-6 col-md-12">
							<div className="case-study-content">
								<span className="sub-title">
									<img src={starIcon} alt="banner" />
									Crowlr💎Talent Network
								</span>
								<h2>{t("home.Eh2")}</h2>
								<p>{t("home.Ep01")}</p>
								<p>{t("home.Ep02")}</p>
							</div>
						</div>

						<div className="col-lg-6 col-md-12">
							<div className="case-study-image">
								<img src={study1} alt="banner" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default E;
